import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {finalize} from 'rxjs';
import {ContaService} from 'src/app/api/module/erp/services/auth/conta.service';
import {ErrorLoggingService} from 'src/app/api/module/erp/shared/services/error-logs/error-logging.service';
import {SpinnerService} from 'src/app/api/module/erp/shared/services/spinner-service.service';
import {CaptchaComponent} from '../../area-logada/shared/components/captcha/captcha.component';
declare var grecaptcha: any;
@Component({
  selector: 'app-resetar-senha',
  templateUrl: './resetar-senha.component.html',
  styleUrls: ['./resetar-senha.component.scss'],
})
export class ResetarSenhaComponent implements OnInit {
  messageSucesso: string | undefined;
  public ResetarSenhaVM: any = {};

  emailEnviado!: boolean;
  userId!: any;
  password!: string;
  confirmPassword!: string;
  token!: any;
  showPassword: Boolean = false;
  tokenPrimeiroAcesso!: any;

  captchaToken: string | null = null;
  @ViewChild('captcha') captcha: CaptchaComponent;

  constructor(
    private contaService: ContaService,
    private toastr: ToastrService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private _spinnerService: SpinnerService,
    private _errorLogging: ErrorLoggingService,
  ) {}
  ngOnInit(): void {
    this.getParametrosUrl();
  }
  iniciarSpinner() {
    this._spinnerService.show();
  }

  pararSpinner(ms?: number) {
    return new Promise(resolve => {
      setTimeout(() => {
        this._spinnerService.hide();
        resolve(true);
      }, ms);
    });
  }
  showHidePassword() {
    this.showPassword = !this.showPassword;
  }
  onRedirectCadastro() {
    this.router.navigate(['/cadastro']);
  }
  onRedirectLogin() {
    this.router.navigate(['/login']);
  }

  onResetarSenha() {
    if (!this.captchaToken) {
      this.toastr.error(' Por favor, complete o CAPTCHA antes de enviar.', 'Aviso');
      return;
    }

    try {
      this.iniciarSpinner();
      this.ResetarSenhaVM.token = this.token[0];
      this.contaService
        .onResetarSenha(this.ResetarSenhaVM, this.userId, this.captchaToken)
        .pipe(
          finalize(() => {
            this.pararSpinner();
          }),
        )
        .subscribe(
          data => {
            this.toastr.success('Operação Realizada com sucesso!');
            this.captchaToken = null;
            this.captcha.reset();
            window.localStorage.clear();
            this.onRedirectLogin();
          },

          (erro: any) => {
            const erroVM = {
              ResetarSenhaVM: this.ResetarSenhaVM,
              dResetarSenhaVM: this.userId,
            };

            this.pararSpinner();
            let mensagemTratada = erro.message.replace('Error:', '');
            if (mensagemTratada.includes('[object Object]')) mensagemTratada = 'Erro ao tentar resetar a senha!';
            (this.erroSentry('Erro ao tentar resetar a senha!', erro, 'Erro ao tentar resetar a senha!', erroVM),
              this.toastr.error(mensagemTratada));
          },
        );
    } catch (error) {
      this.captchaToken = null;
      this.captcha.reset();
      this.pararSpinner();
    }
  }

  getParametrosUrl() {
    this.activatedRoute.queryParamMap.subscribe(params => {
      this.userId = params.getAll('userid');
      this.token = params.getAll('token');
    });
  }

  erroSentry(tituloErro: any, erro: any, mensagemErro: any, data: any) {
    this._errorLogging.logError(mensagemErro, data, {
      contexto: tituloErro,
      data: data,
    });
  }
}
